import { StoreAction } from "./actions";
import { StoreState } from "./state";

export function reducer(state: StoreState, action: StoreAction): StoreState {
  switch (action.type) {
    case "user-picked-preferred-segment": {
      return { ...state, userPreferredSegmentKey: action.value, showSegmentSelector: false };
    }

    case "user-changed-segment": {
      return { ...state, userPreferredSegmentKey: action.value, showSegmentSelector: false };
    }

    case "user-dismissed-segment-selection": {
      return { ...state, userPreferredSegmentKey: action.pageSegmentKey, showSegmentSelector: false };
    }

    case "segment-selector-dismissed": {
      return { ...state, showSegmentSelector: false };
    }

    case "set-user-preferred-locale": {
      return { ...state, userPreferredLocale: action.value, withLocaleMismatchOverlay: false };
    }

    case "user-landed-in-non-localized-page": {
      return { ...state, showSegmentSelector: true };
    }

    case "set-header-floating-disabled": {
      return { ...state, headerFloatingDisabled: action.value };
    }

    default: {
      const _: never = action;

      return _;
    }
  }
}
